import { render, staticRenderFns } from "./deliveries.vue?vue&type=template&id=2708a96b&"
import script from "./deliveries.vue?vue&type=script&lang=js&"
export * from "./deliveries.vue?vue&type=script&lang=js&"
import style0 from "./deliveries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports